const ADMIN_DOMAINS = ["lego.com", "LEGO.com", "pentatonic.com"];

export const isAdminEmail = (email) =>
  ADMIN_DOMAINS.includes(email?.split("@").at(-1));
